<template>
  <div class="p-2 w-full">
    <div class="template">
      {{data.questions}}
      <div v-for="(q, index) in data.questions">
        <Question :question="q" :key="index" />
      </div>

      <button @click="addQuestion()"
              class="btn btn-accent">Add question</button>
    </div>
  </div>
</template>
<script setup lang="ts">
import {reactive} from "vue";
import Question from "~/components/dashboard/templates/question.vue";

let data = reactive({
  questions: []
})
let addQuestion = () => {
  data.questions.push({
    title : 'Title',
    order : data.questions.length,
    type : 'text',
    props: {}
  });
}
</script>